var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-scroll-container",style:({
        height: _vm.finalHeight
     }),on:{"wheel":_vm.scrollHorizontal}},[_c('div',{ref:"wrapperScroll",staticClass:"horizontal-scroll-wrapper d-flex"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37830211","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-horizontal-scrolling.vue
// module id = null
// module chunks = 